export default __webpack_public_path__ + "static/media/About_A_Mobile.88f5815a.png";